import { render, staticRenderFns } from "./ReportShow.vue?vue&type=template&id=3975af60&scoped=true&"
import script from "./ReportShow.vue?vue&type=script&lang=ts&"
export * from "./ReportShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975af60",
  null
  
)

export default component.exports